import { createClient } from '@supabase/supabase-js';

// Obtener las variables de entorno
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validar que las variables de entorno estén configuradas
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    '❌ Faltan las variables de entorno de Supabase.\n' +
    'Por favor, configura VITE_SUPABASE_URL y VITE_SUPABASE_ANON_KEY en tu archivo .env\n' +
    'Ver ROADMAP.md para instrucciones.'
  );
}

/**
 * Cliente Singleton de Supabase
 * 
 * IMPORTANTE: Usa siempre este cliente, NO crees múltiples instancias.
 * 
 * Uso:
 * ```typescript
 * import { supabase } from '@/lib/supabase';
 * 
 * const { data, error } = await supabase
 *   .from('products')
 *   .select('*')
 *   .eq('tenant_id', currentTenantId);
 * ```
 */
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
